import type { InputField, InputKey, InputState } from './types';

export const ft2 = (
  <>
    {'[Ft.'}
    <sup>{'2'}</sup>
    {']'}
  </>
);

export const inputFields: InputField[] = [
  {
    key: 'At_ft2',
    label: (
      <>
        {'Throat Area (A'}
        <sub>{'t'}</sub>
        {')'}
      </>
    ),
    unit: ft2,
    defaultValue: '0.99903',
  },
  {
    key: 'AeAt',
    label: (
      <>
        {'Expansion Ratio ε (A'}
        <sub>{'e'}</sub>
        {'/A'}
        <sub>{'t'}</sub>
        {')'}
      </>
    ),
    unit: '[-]',
    defaultValue: '50.0',
  },
  {
    key: 'AiAt',
    label: (
      <>
        {'Converging Section Area Ratio (A'}
        <sub>{'i'}</sub>
        {'/A'}
        <sub>{'t'}</sub>
        {')'}
      </>
    ),
    unit: '[-]',
    defaultValue: '3.9925',
    geometryOnly: true,
  },
  {
    key: 'Pt_psi',
    label: (
      <>
        {'Chamber Pressure (P'}
        <sub>{'t'}</sub>
        {')'}
      </>
    ),
    unit: '[PSI]',
    defaultValue: '1999.2',
  },
  {
    key: 'P0_psi',
    label: (
      <>
        {'Ambient Pressure (P'}
        <sub>{'0'}</sub>
        {')'}
      </>
    ),
    unit: '[PSI]',
    defaultValue: '14.7',
  },
  {
    key: 'Tt_F',
    label: (
      <>
        {'Total Stagnation Temperature (Tt'}
        <sub>{'0'}</sub>
        {')'}
      </>
    ),
    unit: '[°F]',
    defaultValue: '4000',
  },
  {
    key: 'gamma',
    label: 'Ratio of Specific Heats γ',
    unit: '[-]',
    defaultValue: '1.293',
  },
  {
    key: 'MW',
    label: 'Molecular Weight (MW)',
    unit: '[g/mol]',
    defaultValue: '28.97',
  },
];

export const defaultInputs: InputState = Object.fromEntries(
  inputFields.map((f) => [f.key, f.defaultValue]),
) as InputState;

// ---------------------------------------------------------------------------
// Formatting helpers — shared (issue #128); these were byte-identical to the
// copies in featureTreeSidebar/rocketNozzle.tsx. Re-exported for back-compat.
// ---------------------------------------------------------------------------

export { parseNum, fmt } from '@/lib/physics/rocketNozzleOutputs';

export type { InputKey };
